<template>
  <div id="configuratorStool3d">
    <canvas ref="bjsCanvas" style="width: 100%; height: 100%;"/>
  </div>
</template>

<script>
import myScene from "../scenes/StoolScene";

export default {
  name: 'ConfiguratorStool3d',
  data() {
    return{
      fullyLoaded: false,
    }
   },
   components: {
     },
   computed: {
     planksChange(){ return this.getPlanks.used[0].index },
     getDimensions() {return this.$store.getters.getStoolConfig.dimensions;},
     getFrameColor(){return this.$store.getters.getStoolConfig.color.hex},
     getFrameType(){return this.$store.getters.getStoolConfig.frameType},
     getPlanks() {return this.$store.getters.getStoolConfig.planks;},

     legHeight(){ return this.getDimensions.height-4},
     legXposition(){ return (this.getDimensions.length-7)/2},
     legYposition(){ return (this.getDimensions.height-4)/2},
     frameTopLength(){ return this.getDimensions.length-3},
     frameTopYposition() { return this.getDimensions.height-6},
     plankLength(){ return this.getDimensions.length},
     plankYposition(){ return this.getDimensions.height-2},
     frameZposition(){ return this.legXposition},
     legZposition(){
       var position = this.legXposition
       if (this.getFrameType == 'massive'){ position -= 1 }
       return position
     },
     getLegsDepth(){
       var depth = 4
       if (this.getFrameType == 'simple'){ depth = 4
       } else if (this.getFrameType == 'massive'){ depth = 6}
       return depth
     },
     getFrameRedColor() { return parseInt(this.getFrameColor.slice(1,3), 16)/256;},
     getFrameGreenColor() { return parseInt(this.getFrameColor.slice(3,5), 16)/256;},
     getFrameBlueColor() { return parseInt(this.getFrameColor.slice(5,8), 16)/256;},

     getMobile(){return this.$store.getters.getAnimationProperties.mobile},
     cameraStandard(){
       var distance = 180
       if(this.getMobile){
         distance = 220
       }
       var value = {
         alpha: 310,
         beta: 60,
         radius: distance
       }
       return value
     },
     cameraWood(){
       var distance = 180
       if(this.getMobile){
         distance = 220
       }
       var value = {
         alpha: 270,
         beta: 0,
         radius: distance
       }
       return value
     }
   },
   methods: {
   },
   mounted (){
     const bjsCanvas = this.$refs.bjsCanvas;
     if (bjsCanvas) {
       myScene.createScene(bjsCanvas);
     }
     myScene.setHeight(this.legHeight, this.legYposition, this.frameTopYposition);
     myScene.setFrameType(this.getLegsDepth, this.legZposition);
     myScene.setPlank(this.getPlanks.availablePlanks[this.getPlanks.used[0].index]);
     myScene.setColor(this.getFrameRedColor, this.getFrameGreenColor, this.getFrameBlueColor);
   },
   watch: {
     legHeight(){
       myScene.setHeight(this.legHeight, this.legYposition, this.frameTopYposition);
     },
     getFrameType(){
       myScene.setFrameType(this.getLegsDepth, this.legZposition);
     },
     planksChange(){
       myScene.setPlank(this.getPlanks.availablePlanks[this.getPlanks.used[0].index]);
     },
     getFrameColor(){
       myScene.setColor(this.getFrameRedColor, this.getFrameGreenColor, this.getFrameBlueColor);
     },
   },
}
</script>

<style scoped>
  #configuratorStool3d {
    height: 100%;
    width: 100%;
  }
  #renderCanvas {
    width: 100%;
    height: 100%;
    touch-action: none;
  }
</style>
